module.exports = __webpack_public_path__ + "img/images_marketing_bg3.3c849d71.png";